import axios from "axios";

const PREFIJO = "/api/TpDcmt/"

export default {
    tipoDocumento(idTipoPersona){
        const dto = {
            dt1:process.env.VUE_APP_PAIS_NAME,
            ndt1: idTipoPersona
        }
        return axios.post(`${PREFIJO}VmTpDc`,dto);
    }
}